/* global jQuery, window, document */
import map from 'lodash/fp/map';

(($) => {
  $('body').once('cidrap.project-menu').each(() => {
    const view = document.querySelector('.view-special-project-menu');
    const menu = view.querySelector('ul.special-project-menu');
    if (menu) {
      const mobileMenu = menu.cloneNode(true);
      map(el => el.removeAttribute('id'), mobileMenu.querySelectorAll('[id]'));
      mobileMenu.classList.remove('special-project-menu');
      mobileMenu.classList.add('special-project-menu-mobile');
      const button = document.createElement('button');
      const span = document.createElement('span');
      span.innerHTML = 'In this section';
      button.appendChild(span);
      const animationWrapper = document.createElement('div');
      animationWrapper.appendChild(mobileMenu);
      button.onclick = () => $(animationWrapper).slideToggle();
      const wrapper = document.createElement('div');
      wrapper.classList.add('special-project-menu-mobile-wrapper');
      wrapper.appendChild(button);
      wrapper.appendChild(animationWrapper);
      menu.parentNode.appendChild(wrapper);
    }
  });
})(jQuery);
